<template>
  <div class="preview-box">
    <progressBar
      v-if="showProgress"
      :progress-data="progressData"
      @changeProgressStatus="changeProgressStatus"
      @showTips="handleProcessTips"
    />
    <div
      v-if="!ifCloseCopymoveDialog"
      :class="{'is-ie':isIE}"
      class="copymove-box"
    >
      <el-input
        v-if="haveSort"
        v-model="searchData"
        v-ie-placeholder
        :placeholder="canSort ? $t('搜索文件夹') : $t('暂不支持搜索')"
        class="copymove-search"
        :disabled="!canSort"
      >
        <span
          v-show="searchData"
          slot="suffix"
          class="search-clear"
        >
          <span
            v-show="isSearchLoading"
            class="icon-loading"
          >
            <img
              src="~image/search-load.gif"
              alt=""
            >
          </span>
          <span
            class="icon el-icon-circle-close"
            @click="clearAll"
          />
        </span>
      </el-input>
      <div
        v-else
        class="copymove-nosearch"
      />
      <div
        v-show="crumbData.length < 2"
        class="crumb-title"
      >
        <span>{{ $t('所有目录') }}</span>
      </div>
      <div
        class="copymove-content"
        :class="{'content-havesort':haveSort}"
      >
        <div
          v-show="crumbData.length > 1"
          class="copymove-crumb"
        >
          <crumb
            :crumb-data="crumbData"
            :crumb-title="searchTitle"
            @crumbJump="crumbJump"
          />
        </div>
        <div
          v-if="listData.length > 0 || showCreateFolder"
          id="copymove-scroll-list"
          class="copymove-list"
          :class="{'copymove-list-havesort':haveSort}"
          @scroll="loadMore($event)"
        >
          <div
            v-if="showCreateFolder"
            ref="newLine"
            class="new-folder"
            @click.stop=""
          />
          <div
            v-for="(item,index) in listData"
            :key="index"
            class="list-item"
            :class="{'item-selected': item.checked, 'item-search':isSearchList}"
            @mouseup="itemClick(item)"
            @dblclick="dbClick(item)"
          >
            <svg
              class="file-icon"
              :class="{'isRoot':!haveSort }"
            >
              <use :xlink:href="getIcon(item)" />
            </svg>
            <div class="file-info">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getName(item)"
                :open-delay="1000"
              >
                <div class="file-name">
                  <span v-html="getName(item)" />
                </div>
              </el-tooltip>
              <el-tooltip
                v-if="isSearchList"
                class="item"
                effect="dark"
                :content="getPath(item)"
                :open-delay="1000"
              >
                <div class="file-path">
                  <span>{{ getPath(item) }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div
          v-else
          class="copymove-list-empty"
          :class="{'copymove-list-empty-havesort':haveSort}"
        >
          <span v-if="isSearchList">{{ $t('无符合条件的搜索结果') }}</span>
          <span v-else>{{ $t('文件夹为空') }}</span>
        </div>
      </div>
      <div
        v-if="!ispkg"
        class="copymove-footer"
      >
        <button
          v-show="!isSearchList"
          class="lv-bn lv-80 default-btn s-btn"
          :class="[!actionCreate ? 'c-btn-disabled disabled': '' ]"
          @click="createFolder"
        >
          {{ $t('新建文件夹') }}
        </button>
        <div
          v-show="dc_warn"
          class="warn-txt"
        >
          {{ $t('无法移动/复制到不同数据中心') }}
        </div>
        <div class="copymove-btn">
          <button
            class="lv-bn  lv-80 lv-rm-12 c-btn default-btn"
            @click="handleClick('cancle')"
          >
            {{ $t('取消') }}
          </button>
          <button
            class="lv-bn s-btn lv-80 default-btn"
            :class="[actionTransfer === false ? 'disabled' : '']"
            @click="handleClick('sure')"
          >
            {{ $t('确定') }}
          </button>
        </div>
      </div>
      <slot
        name="pkg"
        :data="{dc_warn, currentData,currentListData, canCopyMove,isSearchList}"
      />
    </div>
    <CreateFolder
      ref="newFolder"
      :current-path="currentListData.path"
      :goal-node="currentListData"
      :from-copy-move="true"
      visible.sync
      @showTips="showTips"
      @refreshList="refreshList"
      @addNewFolderNode="addNewFolderNode"
      @delNewFolderNode="delNewFolderNode"
      @append="append"
    />
    <confirm
      :value.sync="showConfirm"
      :content="$t(content)"
      :title="$t(title)"
      :icon-type="confirmIcontype"
      :single-button="!(confirmButton && cancelButton)"
      :confirm-button="confirmButton"
      :cancel="cancelButton"
      @confirm="action"
      @closed="closeConfirm"
    />
    <confirm
      ref="errorTips"
      :cancel="errorTipCancelButton"
      :confirm-button="errorTipConfirmButton"
      :content="$t(errormessage)"
      :icon-type="errorIcontype"
      :single-button="!(errorTipConfirmButton && errorTipCancelButton)"
      :title="$t(errorTipTitle)"
      :value.sync="errorTipsVisible"
      @closed="handleErrorTipClose"
      @confirm="handleErrorTipConfirm"
    />
  </div>
</template>

<script lang="js">

import * as Util from 'js/util/util'
import store from 'store'
import confirm from 'components/common/confirm/index.vue'
import crumb from 'components/common/transfer/crumb.vue'
import CreateFolder from 'components/common/createFolder/index.vue'
import progressBar from 'components/common/progressBar/progress-bar.vue'
import transferDialog from 'components/common/dialog'

const { getData, postData, getDataAbort } = require('js/api/getdata').default

export default {
  components: {
    confirm,
    crumb,
    CreateFolder,
    progressBar,
  },
  props: {
    isShow: {
      type: Boolean,
    },
    curData: {
      type: Array,
    },
    ispkg: {
      type: Boolean,
      default: false,
    },
    targetPath: {
      require: true,
      type: Number,
    },
    saveStatus: {
      type: Number,
      require: true,
    },
    childContent: {
      type: Array,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      errorTipConfirmButton: '',
      errorTipCancelButton: '',
      errormessage: '',
      errorTipTitle: '',
      errorIcontype: '',
      errorTipsVisible: false,
      ifCloseCopymoveDialog: false,
      page_num: 0,
      has_more: true,
      listData: [],
      currentData: {}, // 移动复制列表当前选中文件夹
      currentListData: {}, // 移动复制当前列表目录的数据
      // 初始默认根目录不可移动，复制，创建文件夹
      actionCreate: false,
      actionTransfer: false,
      // 文件本身权限判断结果
      canCopyMove: true,
      dc_warn: false,
      clickTimerData: {
        timer: null,
        timeStamp: 200,
      },
      searchTimerData: {
        timer: null,
        timeStamp: 1000,
      },
      isSearchList: false,
      crumbData: [],
      loadingMore: false,
      limit: 20,
      offset: 0,
      prefix_nsid: '',
      searchData: '', // 搜索框内的数据
      isSearchLoading: false, // 是否正在搜索
      isLastSearch: false,
      currentSearchData: {}, // 当前进行搜索的目录信息
      prefix_neid: '', // prefix_neid 同一目录下都是一致的
      content: '',
      pkgNodeData: {}, // 返回给压缩包的节点数据
      title: '',
      confirmButton: '',
      cancelButton: '',
      confirmIcontype: '',
      errorData: {},
      showConfirm: false,
      showProgress: false,
      progressData: {},
      showCreateFolder: false, // 展示新建文件夹
      lastSearchOffset: 0,
      currentDcType: '',
      currentRegionId: null,
    }
  },
  computed: {
    getEntName() {
      return Util.getLanguage() === 'en'
        ? store.getters.custominfo.custom_company_space_en_name
        : store.getters.custominfo.custom_company_space_zh_name
    },
    haveSort() {
      return this.crumbData.length > 1
    },
    isAdmin() {
      const { ABILITY_FILE } = Util.ABILITYCODE
      return Util.isCustomAdministrator(ABILITY_FILE)
    },
    searchTitle() {
      return this.isSearchList ? `${this.$t('搜索范围：')}${this.crumbData.slice(1).join('/')}` : ''
    },
    canSort() {
      return !((this.currentListData.path_type === 'share_out' || this.currentListData.path_type === 'share_in') && this.currentListData.path === '/')
    },
    isIE() {
      return Util.isIE()
    },
    searching() {
      const { name } = this.$route
      return /\w*-search/.test(name)
    },
  },
  watch: {
    crumbData() {
      this.offset = 0
      const cpList = document.querySelector('#copymove-scroll-list')
      if (cpList && cpList.scrollTop) cpList.scrollTop = 0
    },
    searchData(val) {
      clearTimeout(this.searchTimerData.timer)
      if (val) {
        this.searchTimerData.timer = setTimeout(() => {
          this.startSearch()
        }, this.searchTimerData.timeStamp)
      } else {
        this.currentData.page_num = 0 // 清空搜索内容还原搜索页面为0
        if (this.isSearchList) { // 防止搜索列表下 点击进入目录时 进行了两次getListData
          this.offset = 0
          this.currentData = this.currentSearchData
          this.currentSearchData = {}
          this.getListData(this.currentData)
        }
      }
    },
  },
  created() {
    this.getOriginData()
  },
  methods: {
    handleProcessTips({ message, state }) {
      if (state === 412) {
        this.errorTipTitle = this.$t('确认')
        this.errorTipConfirmButton = this.$t('继续')
        this.errorTipCancelButton = this.$t('取消')
        this.errorIcontype = 'warn'
      } else {
        this.errorTipTitle = this.$t('提示')
        this.errorTipConfirmButton = this.$t('确定')
        this.errorIcontype = 'warn'
      }
      this.errorTipState = state
      this.errormessage = message
      this.errorTipsVisible = true
      this.showProgress = false
      this.ifCloseCopymoveDialog = true
    },
    makeSendData() {
      const data = {
        to: this.makeToData(), // 目标参数,
        from: this.makeFromData(), // 被移动复制参数,
        other_data: {
          task_id: parseInt(this.$route.params.taskId, 10),
        },
      }
      return { json: JSON.stringify(data) }
    },
    makeToData() {
      if (this.$refs.tree) {
        this.currentSelectedData = this.$refs.tree.getCurrentNode() // 选中的树节点数据 - 目标文件夹信息
      }
      const {
        path, path_type: pathType, from, neid, prefix_neid, nsid,
      } = this.currentData
      const toPath = {
        root: 'databox',
        path: path || '/',
        path_type: pathType,
        from: from || '',
        nsid,
      }
      if (neid && parseInt(neid, 10) > 0) {
        toPath.neid = neid
      }
      if (prefix_neid && parseInt(prefix_neid, 10) > 0) {
        toPath.prefix_neid = prefix_neid
      }
      return toPath
    },
    makeFromData() {
      const selectedData = this.childContent
      const fromPath = []
      if (selectedData.length > 0) {
        selectedData.forEach((item) => {
          const {
            path,
            path_type: pathType,
            from,
            delivery_dump: deliverDump,
            delivery_creator_uid: deliveryCreatorUid,
            delivery_id: deliveryId,
            neid,
            prefix_neid,
            nsid,
          } = item
          const obj = {
            root: 'databox',
            rev: '',
            path,
            path_type: pathType,
            from,
            delivery_dump: deliverDump,
            delivery_creator_uid: deliveryCreatorUid,
            delivery_id: deliveryId,
            nsid,
          }
          if (neid && parseInt(neid, 10) > 0) {
            obj.neid = neid
          }
          if (parseInt(prefix_neid, 10) > 0) {
            obj.prefix_neid = prefix_neid
          }
          fromPath.push(obj)
        })
      }
      return fromPath
    },
    handleClick(type) {
      if (type === 'cancle') {
        this.$emit('close')
      } else if (type === 'sure' && this.actionTransfer) {
        // 调接口
        const sendata = this.makeSendData()
        postData('copy', sendata).then((res) => {
          if (res.status === 200) {
          // 判断是否需要进度条
            if (res.data.task_type === 2) {
              this.progressData.task_id = res.data.task_id
              this.progressData.mainTxt = this.$t('文件转存中，请稍后...')
              this.changeProgressStatus()
            } else {
              const tips = this.$t('转存成功')
              window.$toast.simpleShow(tips, 'warn')
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          }
        }).catch((error) => {
          window.$toast.simpleShow(error.response.data.message, 'warn')
        })
      }
    },
    getOriginData() {
      if (this.saveStatus === 0) {
        this.listData = [{
          filename: this.getEntName, path: '/', path_type: 'ent', icon: 'ent', neid: '1', checked: false,
        }]
      }
      if (this.saveStatus === 1) {
        this.listData = [{
          filename: this.getEntName, path: '/', path_type: 'ent', icon: 'ent', children: [], neid: '1', checked: false,
        },
        {
          filename: this.$t('个人文件'), path: '/', path_type: 'self', icon: 'self', children: [], neid: '', checked: false,
        }]
      }

      this.currentData = {}
      this.currentListData = {}
      this.crumbData = [this.$t('所有目录')]
      this.setOperationStatus(this.listData)
    },
    getIcon(item) {
      let icontype = ''
      if (item.icon) {
        icontype = `#${item.icon}`
      } else if (item.is_dir) {
        icontype = `#${Util.getFolderType(item)}`
      } else {
        icontype = `#${Util.typeIcon(item.mime_type.split('.').pop())}`
      }
      return icontype
    },
    getName(item) {
      if (this.isSearchList) return item.path.split('/').pop() // 避免搜索结果的<mark>标签
      return item.filename ? item.filename : item.path.split('/').pop()
    },
    getPath(item) {
      let pathType = ''
      const path = item.path === '/' ? '' : item.path
      switch (item.path_type) {
        case 'ent':
          pathType = this.getEntName
          break
        case 'self':
          pathType = this.$t('个人文件')
          break
        default:
      }
      return `${pathType}${path}`
    },
    itemClick(item) {
      clearTimeout(this.clickTimerData.timer)
      this.clickTimerData.timer = setTimeout(() => {
        this.$set(item, 'checked', true)
        this.setCurrentSelect(item)
        this.clearOtherSelect()
      }, this.clickTimerData.timeStamp)
    },
    dbClick(item) {
      clearTimeout(this.clickTimerData.timer)
      this.changeCrumbPath(item)
      this.setCurrentSelect(item)
      this.$nextTick(() => {
        this.currentData.page_num = 0 // 双击目录清空按最初始的查询
        this.getListData(item)
      })
    },
    setCurrentSelect(item) {
      this.currentData = item
      this.setOperationStatus(item)
    },
    clearOtherSelect() {
      this.listData.forEach((element) => {
        if (element.neid !== this.currentData.neid) {
          this.$set(element, 'checked', false)
        }
      })
    },
    loadMore(e) {
      const { target } = e
      if ((target.clientHeight + target.scrollTop) >= (target.scrollHeight - 50)
        && !this.loadingMore && this.offset !== 0) {
        this.loadingMore = true
        if (this.searchData) {
          this.startSearch(true)
          return
        }
        this.getListData(this.currentData, true)
      }
    },
    getListData(item = {}, add) {
      if (!add) this.offset = 0 // 不是下拉加载时，将offset数据置为0
      if (item.page_num === 0) { // 如果传第几页，就按传的用
        this.page_num = 0
      }
      const params = {
        url: item.path,
        prefix_neid: item.prefix_neid,
        path_type: item.path_type ? item.path_type : 'ent',
        neid: item.neid === '0' ? '' : item.neid,
        nsid: item.nsid === 0 ? '' : item.nsid,
        from: item.from,
        page_button_count: 5,
        include_deleted: false,
        page_size: 20,
        waitContent: '.lui-filelist',
        page_num: this.page_num,
        offset: 0,
        sort: 'asc',
        orderby: 'name',
        content_type: 'dir',
      }

      getData('getMetadata', params).then((res) => {
        this.prefix_neid = res.data.prefix_neid
        this.prefix_nsid = res.data.nsid
        this.currentData = res.data
        this.currentListData = res.data
        this.isSearchList = false
        this.searchData = '' // 搜索框中的数据清空
        this.setOperationStatus(this.currentData)
        const datas = res.data.content.filter((v) => v.is_dir || v.isDir) // 文件夹
        if (add) {
          this.listData = this.listData.concat(datas)
        } else {
          this.listData = datas
        }

        this.page_num += 1 // 查询后增加页码用于滚动加载
        this.offset = this.listData.length
        this.loadingMore = false
      })
    },
    setOperationStatus(data) {
      const tempData = data
      if (this.crumbData.length === 1) {
        this.actionCreate = false
        this.actionTransfer = false
        return
      }
      if ((data.access_mode & 1056) === 1056) {
        this.actionCreate = true // 可新建
      } else {
        this.actionCreate = false
      }
      if (Util.isHasAuth(data.access_mode, 'upload')) {
        this.actionTransfer = true
      } else {
        this.actionTransfer = false
      }
      this.dc_warn = !this.canCopyMove
    },
    handleErrorTipConfirm() {
      if (this.errorTipState === 412) {
        this.copyMove(this.actionType, false, true)
      } else {
        this.$emit('closeParentDialog')
      }
    },
    handleErrorTipClose() {
      this.$emit('closeParentDialog')
    },

    addNewFolderNode(cb) {
      this.showCreateFolder = true
      this.$nextTick(() => {
        if (cb) cb(this.$refs.newLine)
      })
    },
    delNewFolderNode() {
      if (this.$refs.newLine && this.$refs.newLine.firstChild) {
        this.showCreateFolder = false
        this.$refs.newLine.removeChild(this.$refs.newLine.firstChild)
      }
    },
    createFolder() {
      if (this.showCreateFolder) { // 正在新建文件夹时，未确认或取消时，不可再次新建 bug4184
        return
      }
      if (!this.actionCreate) {
        return
      }
      // 选中的nsid和pid传到vuex中
      store.commit('SET_SELECT_NSID', this.currentData.nsid)
      store.commit('SET_SELECT_PID', this.currentData.neid)
      const data = {
        dialogTitle: this.$t('新建文件夹'),
        filename: this.$t('新建文件夹'),
        inputLable: this.$t('文件夹名称'),
      }
      const { newFolder } = this.$refs
      newFolder.createFile(data, this.currentData)
    },
    append(data) {
      this.showCreateFolder = false
      this.listData.unshift(data)
    },
    canMove(param) {
      let can = true
      if (param.islocked && !param.unlockAdmin) can = false
      if (Util.isHasAuth(param.access_mode, 'edit') || (param.access_mode & 1026) === 1026) {
        if (param.is_team)can = false
        if (!this.isAdmin && param.path_type === 'ent' && /^\/([^/]+)$/.test(param.path))can = false
        if (/share/.test(param.path_type) && /^\/([^/]+)$/.test(param.path))can = false
      } else if ((param.access_mode & 256) !== 256) {
        can = false
      }
      return can
    },
    canCopy(param) {
      let can = true
      if (param.islocked && !param.unlockAdmin) {
        // 如果是加锁文件，并且自己不是加锁人，但可以复制
        can = true
      }
      if ((param.access_mode & 512) !== 512) {
        can = false
      }
      return can
    },
    changeCrumbPath(param, isCrumbJump) {
      this.isSearchList = false
      if (isCrumbJump) {
        this.crumbData = param.path.split('/')
      } else {
        const path = this.getPath(param)
        this.crumbData = (`${this.$t('所有目录')}/${path}`).split('/')
      }
    },
    crumbJump(param) {
      this.changeCrumbPath(param, true)
      this.$nextTick(() => {
        if (param.index === 0) { // 跳转至所有目录
          this.getOriginData()
        } else {
          const data = {
            path_type: this.currentData.path_type, // 和跳转前选中目录的path_type是一致的 所以直接取
            path: `/${param.path.split('/').slice(2).join('/')}`, // path截取
            neid: '',
            prefix_neid: this.prefix_neid || '',
            page_num: 0,
          }
          this.getListData(data)
        }
      })
    },
    async startSearch(isAdd) {
      const meta = this.currentListData || {}
      // 新增type: folder只查找文件夹
      const params = {
        limit: this.limit,
        query: this.searchData,
        path: meta.path,
        path_type: meta.path_type,
        prefix_nsid: this.prefix_nsid,
        prefix_neid: meta.neid, // 当前文件目录的neid
        type: 'folder',
        is_full_box: false, // 非全盘搜索
        S: store.getters.S,
      }
      if (isAdd) {
        if (this.lastSearchOffset && !this.isLastSearch) {
          params.offset = this.lastSearchOffset
        }
        params.next_index = this.next_index // 私有必传next_index
      } else {
        this.isLastSearch = false
        params.next_index = 0
      }
      if (this.isLastSearch) {
        return
      }
      this.isSearchLoading = true
      const result = await this.fetchSearch(params)
      this.setOperationStatus(params)
      if (isAdd) {
        if (result) {
          // 私有搜索返回entrys
          this.listData = this.listData.concat(result.entrys.filter((v) => v.is_dir || v.isDir))
        }
      } else if (result) {
        this.listData = result.entrys.filter((v) => v.is_dir || v.isDir)
      }
      // this.searching = true
      this.timeHandler = null
      this.isSearchList = true
      this.currentSearchData = this.currentData // 记录一下在哪个目录下进行的搜索
    },
    fetchSearch(params) {
      const { source, action } = getDataAbort('usualSearch', params)
      window.cancel = source.cancel
      store.commit('SET_SEARCH_CANCEL', source.cancel)
      return action.then((res) => {
        this.isSearchLoading = false
        this.loadingMore = false
        if (!res.data.has_more) {
          this.isLastSearch = true
        }
        this.lastSearchOffset = res.data.next_offset
        this.next_index = res.data.next_index
        this.has_more = res.data.next_index === 0 ? true : res.data.has_more
        store.commit('SET_SEARCH_CANCEL')
        return res.data
      }, (err) => {
        console.error('search error:', err)
      })
    },
    clearAll() {
      this.searchData = '' // 会通过对searchData的watch回到之前的列表
    },
    refreshList() {
      if (/\w*-detail/.test(this.$route.name)) {
        this.$emit('getData', {
          neid: this.$route.params.id, nsid: this.selectedData[0].data.nsid, refresh: true, type: 'copymove',
        })
      } else {
        this.$emit('getData', { neid: this.$route.params.id, refresh: true, type: 'copymove' })
      }
    },
    closeConfirm() {
      this.errorData = {}
      this.showConfirm = false
    },
    showTips(data, type) {
      if (type && type === 'success') {
        this.$emit('showTips', data, type)
      } else {
        this.title = this.$t('提示')
        this.content = data
        this.confirmButton = this.$t('确定')
        this.errorData.showTips = true
        this.showConfirm = true
        this.cancelButton = ''
        this.confirmIcontype = 'warn'
      }
    },
    action() {
      if (this.errorData.sameFile || this.errorData.showTips) {
        return
      }
      this.copyMove(this.errorData.type, this.errorData.rename, this.errorData.share)
    },
    changeProgressStatus(progress) {
      this.showProgress = !this.showProgress
      if (progress === 100) {
        const tips = this.$t('转存成功')
        window.$toast.simpleShow(tips, 'warn')
        setTimeout(() => {
          this.$emit('close')
          window.location.reload()
        }, 2000)
      }
    },
  },
}
</script>

<style lang="less">
.copymove-box{
  margin: 0 24px 24px;
  .copymove-search{
    input{
      height:32px;
      border-color: #E8EBEF;
      line-height: normal;
      &.el-input__inner:focus,&.el-input__inner:hover{
        border-color: #E8EBEF;
      }
    }
    .search-clear{
      display: inline-block;
      margin: 8px 8px 0 0;
      .icon-loading {
        display: inline-block;
        background-color: #fff;
        height: 20px;
        line-height: 20px;
        width: 20px;
        margin-right: 8px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .crumb-title{
    padding-bottom: 8px;
    span{
      font-size: 14px;
      color: #1B2733;
    }
  }
  .copymove-list-empty{
    height: 368px;
    line-height: 360px;
    text-align: center;
    &.copymove-list-empty-havesort{
      height: 334px;
      line-height: 326px;
    }
    span{
      font-size:14px;
      color: #637282;
    }
  }
  // ie样式兼容
  &.is-ie{
    .file-icon{
      margin-top: -12px;
      &.isRoot{
        margin-top: -8px!important; //根目录下 icon小 兼容
      }
    }
  }
  .copymove-content{
    border: 1px solid #E8EBEF;
    &.content-havesort{
      border-top: none;
    }
    .copymove-crumb{
      padding-left: 16px;
      background: #F6F7FA;
      height: 24px;
      line-height: 24px;
    }
    .copymove-list{
      overflow-y: auto;
      overflow-x: hidden;
      height: 360px;
      margin-top: 8px;
      &.copymove-list-havesort{
        height: 326px;
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        margin-left: 20px;
        background: #C1C7CD;
        border-radius: 3px;
      }
      .list-item{
        height: 36px;
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        &:hover{
          background-color: #F6F7FA;
        }
        &.item-selected{
          background-color: #F6F7FA;
        }
        &.item-search{
          height: 56px;
        }
        .file-icon{
          float: left;
          width: 20px;
          height: 20px;
          margin-left: 16px;
          position: absolute;
          &.isRoot{
            margin-top: 2px;
          }
        }
        .file-info{
          margin-left: 45px;
          overflow: hidden;
          div{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: fit-content;
            max-width: 100%;
          }
          span{
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .file-name{
            height: 20px;
            line-height: 20px;
            span{
              font-size: 14px;
              color: #1B2733;
            }
          }
          .file-path{
            height: 16px;
            line-height: 16px;
            span{
              font-size: 12px;
              color: #637282;
            }
          }
        }
      }
      .new-folder{
        .file-area {
          .file-icon {
            display: inline-block;
            height: 20px;
            vertical-align: middle;
            width: 20px;
            padding: 0 8px 0 16px;
          }
          input {
            border: 1px solid #ddd;
            border-radius: 3px;
            height: 25px;
            line-height: 22px;
            text-indent: 2px;
            width: 330px;
            padding-right: 60px;
          }
          .wrap-btns{
            margin: 1px 0 0 -60px;
          }
        }
      }
    }
  }
  .copymove-footer{
    margin-top: 24px;
    .warn-txt{
      display: inline;
      font-size: 12px;
      color: red;
      margin-left:8px;
    }
    .copymove-btn{
      float: right;
      margin-bottom: 24px;
      .default-btn {
          cursor: pointer;
          &.disabled{
            background: rgba(10,100,250,0.6);
            border-color: rgba(10,100,250,0.6);
            cursor: default ;
        }
      }
    }
  }
}
</style>
